(function (module) {
    "use strict";

    module.component('skuForecast', {
        template: require('./skuForecastComponent.html'),
        bindings: {
            parameters: '<',
            stepEnter: "=",
            market: "<",
            brands: "=",
            validationError: "<",
            isEditable: "<"
        },
        controller: ['$scope', '$timeout',  function(
            this: $TSFixMe,
            $scope: $TSFixMe,
            $timeout: ng.ITimeoutService
        ) {
            var $ctrl = this;

            $ctrl.callbacks = {};
            
            $ctrl.$onInit = function(){
                var ctrl = $ctrl;
                $scope.$watch('$ctrl.selectedSku', function(value: $TSFixMe){
                    if (value){
                        $timeout(function(){
                            if ($ctrl.callbacks.onEnter){
                                $ctrl.callbacks.onEnter();
                            }
                        });
                    }                        
                });

            }


        }]
    })

})(angular.module('topline.modules'));